import React from 'react'
import PropTypes from 'prop-types'
import { getCountryCodesForPhoneInput } from '@fielded/fs-api/lib/location/tools/location-locale'

import { Form, Page, Text, Button } from '@fielded/shared-ui'
import EntryViewWrapper from '../common/EntryViewWrapper'
import { Mail, Mobile, Arrow } from '@fielded/shared-ui/src/icons'

const countryCodes = getCountryCodesForPhoneInput()

const ForgotPassword = ({
  config,
  currentStep,
  onMethodSelect,
  onSubmit,
  inProcess,
  error,
  onBack
}) => {
  // Step 1: Method Selection
  if (currentStep === 'method-selection') {
    return (
      <EntryViewWrapper config={config}>
        <Page.Panel.Section>
          <div className='login__panel-title'>
            Choose how to reset your password
          </div>
        </Page.Panel.Section>

        <Page.Panel.Section>
          <Text>
            Pick the method that works best for you.
          </Text>
        </Page.Panel.Section>

        {error && (
          <Page.Panel.Message type='danger' cta={false}>
            {error}
          </Page.Panel.Message>
        )}

        <Page.Panel.Section>
          <Form.Button
            type='button'
            onClick={() => onMethodSelect('email')}
            disabled={inProcess}
            size='large'
            fill='outline'
            shape='square'
            colorVariant='brand'
            icon={<Mail />}
            style={{ marginBottom: '12px', width: '100%', textAlign: 'left' }}
          >
            Reset using email
          </Form.Button>

          <Form.Button
            type='button'
            onClick={() => onMethodSelect('phone')}
            disabled={inProcess}
            size='large'
            fill='outline'
            shape='square'
            colorVariant='brand'
            icon={<Mobile />}
            style={{ width: '100%', textAlign: 'left' }}
          >
            Reset using phone number
          </Form.Button>
        </Page.Panel.Section>

        <Page.Panel.Section>
          <Button
            href='/login'
            fill='none'
            size='regular'
            icon={<Arrow direction='left' />}
            iconSide='left'
            colorVariant='brand'
          >
            go back
          </Button>
        </Page.Panel.Section>
      </EntryViewWrapper>
    )
  }

  // Step 2: Email Input Form
  if (currentStep === 'email-input') {
    return (
      <EntryViewWrapper config={config}>
        <Page.Panel.Section>
          <div className='login__panel-title'>
            Reset using email
          </div>
        </Page.Panel.Section>

        <Page.Panel.Section>
          <Text>
            Enter the email used to create your account. <br />
            We'll send you a 6-digit code to reset your password.
          </Text>
        </Page.Panel.Section>

        {error && (
          <Page.Panel.Message type='danger' cta={false}>
            {error}
          </Page.Panel.Message>
        )}

        <Page.Panel.Section>
          <Form
            onSubmit={onSubmit}
            component='form'
          >
            <Form.Row>
              <Form.Field
                fieldName='email'
                labelText='Email address'
              >
                <Form.Field.Text
                  autoFocus
                  placeholder='Enter your email address'
                  required='Please provide an email'
                  type='email'
                  disabled={inProcess}
                  autoCapitalize='off'
                />
                <Form.Field.ValidationErrors />
              </Form.Field>
            </Form.Row>

            <Form.Actions layout='left'>
              <Form.Button
                size='regular'
                disabled={inProcess}
                loading={inProcess}
              >
                Send code
              </Form.Button>
            </Form.Actions>
            <Form.Actions layout='left'>
              <Button
                fill='none'
                size='regular'
                icon={<Arrow direction='left' />}
                iconSide='left'
                colorVariant='brand'
                onClick={onBack}
              >
                go back
              </Button>
            </Form.Actions>
          </Form>
        </Page.Panel.Section>
      </EntryViewWrapper>
    )
  }

  // Step 3: Phone Input Form
  if (currentStep === 'phone-input') {
    return (
      <EntryViewWrapper config={config}>
        <Page.Panel.Section>
          <div className='login__panel-title'>
            Reset using phone number
          </div>
        </Page.Panel.Section>

        <Page.Panel.Section>
          <Text>
            Enter the phone number linked to your account. <br />
            We'll send a 6-digit code to help you reset your password.
          </Text>
        </Page.Panel.Section>

        {error && (
          <Page.Panel.Message type='danger' cta={false}>
            {error}
          </Page.Panel.Message>
        )}

        <Page.Panel.Section>
          <Form
            onSubmit={onSubmit}
            component='form'
          >

            <Form.Row>
              <Form.Field
                fieldName='phoneNumber'
                labelText='Phone number'
              >
                <Form.Field.PhoneInput
                  autoFocus
                  required='Please provide a phone number'
                  disabled={inProcess}
                  countryCodes={countryCodes}
                />
                <Form.Field.ValidationErrors />
              </Form.Field>
            </Form.Row>

            <Form.Actions layout='left'>
              <Form.Button
                size='regular'
                disabled={inProcess}
                loading={inProcess}
              >
                Send code
              </Form.Button>
            </Form.Actions>
            <Form.Actions layout='left'>
              <Button
                fill='none'
                size='regular'
                icon={<Arrow direction='left' />}
                iconSide='left'
                colorVariant='brand'
                onClick={onBack}
              >
                go back
              </Button>
            </Form.Actions>

          </Form>
        </Page.Panel.Section>
      </EntryViewWrapper>
    )
  }

  return null
}

ForgotPassword.propTypes = {
  config: PropTypes.object.isRequired,
  currentStep: PropTypes.oneOf(['method-selection', 'email-input', 'phone-input']).isRequired,
  onMethodSelect: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  inProcess: PropTypes.bool,
  error: PropTypes.string,
  onBack: PropTypes.func.isRequired
}

ForgotPassword.defaultProps = {
  inProcess: false,
  error: null
}

export default ForgotPassword
